/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePersonRequest } from '../models/CreatePersonRequest';
import type { OpenApiInteger } from '../models/OpenApiInteger';
import type { Person } from '../models/Person';
import type { UpdatePersonRequest } from '../models/UpdatePersonRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PeopleService {

    /**
     * @param requestBody
     * @returns Person Success
     * @throws ApiError
     */
    public static createForUser(
        requestBody: CreatePersonRequest,
    ): CancelablePromise<Person> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/people/create-for-user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Person Success
     * @throws ApiError
     */
    public static updatePerson(
        id: OpenApiInteger,
        requestBody: UpdatePersonRequest,
    ): CancelablePromise<Person> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/people/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
